import { useState, useCallback } from 'react';
import { RESPONSE_TYPES } from 'ai/constants/superchat';
import { getSuperChatPageContextFromEntryPoint, trackSuperChatFollowUpClick } from 'ai/utils/trackSuperChatPromptClick';

const useSuperChatContextualChips = ({ messages, entryPointData, sendMessageRef, socketServiceRef }) => {
    const [hiddenContextualChips, setHiddenContextualChips] = useState(new Set());
    const [latestContextualChipIndex, setLatestContextualChipIndex] = useState(-1);

    const hideChip = useCallback(index => {
        setHiddenContextualChips(prev => new Set(prev).add(index));
    }, []);

    const resetHiddenChips = useCallback(() => {
        setHiddenContextualChips(new Set());
    }, []);

    const handleChipClick = useCallback(
        chip => {
            const pageContext = getSuperChatPageContextFromEntryPoint(entryPointData);

            let followUpMessage = null;

            for (let i = messages.length - 1; i >= 0; i--) {
                if (messages[i].response_type === RESPONSE_TYPES.FOLLOW_UP_MESSAGES_RESPONSE) {
                    followUpMessage = messages[i];

                    break;
                }
            }

            const messageId = followUpMessage?.message_id || followUpMessage?.data?.message_id || '';
            const previousMessageId = socketServiceRef.current?.lastMessageId || '';

            if (chip?.content) {
                trackSuperChatFollowUpClick({
                    followUpText: chip.content,
                    pageContext,
                    messageId,
                    previousMessageId
                });
            }

            sendMessageRef.current?.(chip.content);

            const messageIndex = messages.length - 1;
            setHiddenContextualChips(prev => new Set(prev).add(messageIndex));
        },
        [messages, entryPointData, sendMessageRef, socketServiceRef]
    );

    return {
        hiddenContextualChips,
        latestContextualChipIndex,
        setLatestContextualChipIndex,
        hideChip,
        resetHiddenChips,
        handleChipClick
    };
};

export default useSuperChatContextualChips;
